import { Link } from "react-router-dom";

const WebisteDetails = ({site}) => {
   
    return (
        <div className="mjsdev-dtl-section mjsdev-dtl-section-half">
            <div className="mjsdev-dtl-sec-header"><h4>Website Details</h4></div>
            <div className="mjsdev-dtl-inner-container">
                <div className="mjsdev-dtl-row">
                    <span>Site Name</span>
                    <span>{site.name || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Email</span>
                    <span>{site.email || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Phone</span>
                    <span>{site.phone || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Address</span>
                    <span>{site.address || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Status</span>
                    <span>{site.status || '-'}</span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Site URL</span>
                    <span><Link className="mjsdev-link" target="_blank" to={site.siteUrl}>{site.name}</Link></span>
                </div>
                <div className="mjsdev-dtl-row">
                    <span>Generated On</span>
                    <span>
                        {new Date(site.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default WebisteDetails;
